import * as React from 'react';

export default function (e: React.KeyboardEvent<any>, action: () => void) {
    const key = e.keyCode || e.which;
    if (key === 13) {
        action();
    }
}